import InlineSvg from "react-inlinesvg";
import styled from "styled-components";

import configStore from "@zustand/configStore";
import { imgList } from "@constants/imgs";
import { colors } from "@constants/colors";

const MaintenanceService = () => {
  const { configMaintenance } = configStore();

  return (
    <ContentStyle>
      <InlineSvg src={imgList.system_maintenance} />
      <div className="title">{configMaintenance?.title}</div>
      <div className="description">{configMaintenance?.description}</div>
    </ContentStyle>
  );
};

export default MaintenanceService;

const ContentStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  .title {
    font-size: 32px;
    font-weight: 600;
    line-height: 40px;
    color: ${colors.graynormal};
    text-align: center;
  }
  .description {
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    width: 80%;
    text-align: center;
    color: ${colors.blackText};
  }
`;
